import reducer from './reducers';
import * as secondFlowsActions from './actions';
import * as secondFlowsSelectors from './selectors';

export { secondFlowsActions, secondFlowsSelectors };
export default reducer;